/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/2/2022
 */
import BaseDataFilter from "@/core/js/backend/filters/BaseDataFilter.js";

export default class DataFilter extends BaseDataFilter {


	constructor(limit) {
		super(limit);
	}
}
